// Map art still on its way that a capture must not shoot without: a text markup waiting for its
// font, or drawn at a soft band until its exact one is painted. A leaf, so waitForMapFrame reads
// it without pulling MapMarkups into every bundle that captures a map.
const pending = new Set<Promise<unknown>>()

export function trackPendingMapArt(work: Promise<unknown>): void {
  pending.add(work)
  const done = (): void => {
    pending.delete(work)
  }
  work.then(done, done)
}

export const hasPendingMapArt = (): boolean => pending.size > 0

/** Settles once every piece of map art tracked so far has, and any it started in turn. */
export async function mapArtSettled(): Promise<void> {
  while (pending.size) {
    await Promise.allSettled([...pending])
  }
}
